import { z } from 'zod';
// barrel(@/shared/billing) 대신 정의 모듈을 직접 참조한다 — node:test 실행 체인 보호.
import { PaymentProvider } from '@/shared/billing/types';

/**
 * 결제 시작 결과 종류 (BE `com.crabs.model.PaymentStartAction` 과 대응).
 *
 * - `TOSS_WIDGET`: Toss 결제 위젯을 띄운다. `tossPaymentInfo` 가 함께 온다.
 * - `PROCESSING`: 서버가 비동기로 결제를 진행한다. 결과 조회로 확정한다.
 * - `REDIRECT`: 외부 결제 페이지로 이동한다. `checkoutUrl` 이 함께 온다.
 * - `COMPLETED`: 이미 결제가 끝났다 (0원 결제 등 게이트웨이 호출 없이 완료된 경우).
 * - `RESERVED`: 즉시 과금 없이 다음 갱신으로 변경이 예약됐다 (Lemon 플랜 변경).
 */
export const PaymentStartAction = {
  TOSS_WIDGET: 'TOSS_WIDGET',
  PROCESSING: 'PROCESSING',
  REDIRECT: 'REDIRECT',
  COMPLETED: 'COMPLETED',
  RESERVED: 'RESERVED',
} as const;
export type PaymentStartAction =
  (typeof PaymentStartAction)[keyof typeof PaymentStartAction];

/** Toss 위젯 구동에 필요한 정보. `actionType === 'TOSS_WIDGET'` 일 때만 내려온다. */
export const TossPaymentInfoScheme = z.object({
  orderId: z.string(),
  orderName: z.string(),
  customerKey: z.string(),
  currency: z.string(),
  amount: z.number(),
  customerEmail: z.string(),
  customerName: z.string(),
  customerMobilePhone: z.string().nullish(),
});

export type TossPaymentInfoType = z.infer<typeof TossPaymentInfoScheme>;

/**
 * 결제 시작 공통 응답 (BE `PaymentStartResponse`).
 * `/payments/confirm`, `/payments/billing/confirm`, `/payments/retry` 가 모두 이 형태를 돌려준다.
 *
 * provider 는 서버가 요청 리전으로 결정한다 — 프론트가 고르지 않는다.
 */
export const PaymentStartResponseScheme = z.object({
  orderId: z.string(),
  provider: z.nativeEnum(PaymentProvider),
  actionType: z.nativeEnum(PaymentStartAction),
  tossPaymentInfo: TossPaymentInfoScheme.nullish(),
  checkoutUrl: z.string().nullish(),
});

export type PaymentStartResponseType = z.infer<
  typeof PaymentStartResponseScheme
>;
